<template>
  <section>
      <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_CREDIT_MEMO)"
        :canDelete="checkClaim(CAN_DELETE_CREDIT_MEMO)"
        :gridId="gridId"
        :pageable="pageable"
        :itemData="itemData"
        :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
        :take="pageInfo.pageSize"
        :pageSizes="pageInfo.pageSize"
        :totalItems="pageInfo.totalItems"
        :sortBy="pageInfo.sortBy"
        :sortOrder="pageInfo.sortOrder"
        :sortMethod="sortGrid"
        :fields="fields"
        :onDelete="onDelete"
        :handleRowClick="onRowClick"
        :isTblLoader="tblLoader"
        :styleCustom="'height: 210px'"
        @getData="onGetData"
      />
  </section>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import { SORT_ORDER, GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from '@/pages/CreditMemos/fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    companyId: {
      type: [Number, String],
      default: null,
    },
    isPending: {
      type: Boolean,
      default: null
    },
    hasBalance: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      filtersVisible: false,
      fields: gridFields,
      gridId: GRID_ID.CREDIT_MEMOS_TAB_GRID,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0
    };
  },
  computed: {
    ...mapGetters('creditMemosComponent', ['creditMemos','pageInfo', 'filters', 'tblLoader']),
    ...mapGetters('account', ['gridSettingsById']),
    itemData() {
      return this.creditMemos;
    },
  },
  methods: {
    ...mapMutations('creditMemosComponent', ['setItem']),
    ...mapActions('creditMemosComponent', ['getAll', 'sortGrid']),
    ...mapActions('creditMemos', ['deleteCreditMemo']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
    },
    async onDelete(item) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete credit memo?`});
      if (deleteConfirmed) {
        const result = await this.deleteCreditMemo(item.id).then(() => this.getAll({}));
        
      }
    },
    async onGetData(params) {
      await this.getAll(params);
    },
  },
  watch: {
    companyId() {
      this.setItem({ resource: 'filters', payload: {...this.filters, companyId: this.companyId} });
    },
    isPending() {
      this.setItem({ resource: 'filters', payload: {...this.filters, isPending: this.isPending} });
    },
    hasBalance() {
      this.setItem({ resource: 'filters', payload: {...this.filters, hasBalance: this.hasBalance} });
    },
    filters() {
      this.getAll({});
    }
  },
  mounted() {
    this.setItem({resource: 'filters', payload: { 
        companyId: this.companyId, 
        hasBalance: this.hasBalance,
        isPending: this.isPending
      }
    });
    // this.getcreditMemos({});  
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
  min-width: 800px;
}
</style>
